var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "#FFF1E8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 61.44C0 62.856 1.144 64 2.56 64H61.44C62.856 64 64 62.856 64 61.44V27.84H0V61.44ZM61.44 5.76H48V0.64C48 0.288 47.712 0 47.36 0H42.88C42.528 0 42.24 0.288 42.24 0.64V5.76H21.76V0.64C21.76 0.288 21.472 0 21.12 0H16.64C16.288 0 16 0.288 16 0.64V5.76H2.56C1.144 5.76 0 6.904 0 8.32V22.4H64V8.32C64 6.904 62.856 5.76 61.44 5.76Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.87c5e207ed0aedb29ff22edddef6c815.svg";
export { ForwardRef as ReactComponent };